/**
 * Registers the built-in engine compilers. This is the single place engines are
 * wired to the registry; add a new engine's compiler here.
 */
import type { CompilerRegistry } from './compiler-registry';
import { defaultRegistry } from './compiler-registry';
import { ClickHouseCompiler } from './sql/clickhouse';
import { PostgresCompiler } from './sql/postgres';
import { ElasticsearchCompiler } from './search-dsl/elasticsearch';
import { OpenSearchCompiler } from './search-dsl/opensearch';

export function registerDefaultCompilers(
    registry: CompilerRegistry = defaultRegistry,
): void {
    registry.register('clickhouse', new ClickHouseCompiler());
    registry.register('postgresql', new PostgresCompiler());
    registry.register('elasticsearch', new ElasticsearchCompiler());
    registry.register('opensearch', new OpenSearchCompiler());
}
